import type {
  IBondScreenerCompany,
  TCompanyType,
} from '@/creditflowresearch/domain/vo/Bondscreener';
import type { ISelectOption } from '@creditflowresearch/uilib/Select';

export interface ICompanyOption extends ISelectOption {
  value: string,
  type: TCompanyType,
  id: string,
}

export const toOptions = (companies: IBondScreenerCompany[], type: TCompanyType): ICompanyOption[] =>
  companies.map(({ id, name, ticker }) => ({
    value: `${ id }:${ type }`,
    label: ticker ? `${ name } (${ ticker })` : name,
    type,
    id,
  }));
